import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { PaginatedResponse } from "@/shared/models/pagination.model";

export interface FetchOrdersParams {
  page?: string | number;
  limit?: string | number;
  startDate?: string;
  endDate?: string;
  updatedStart?: string;
  updatedEnd?: string;
  paymentStatus?: string;
  status?: string;
  employee?: string; // Employee ID
  company?: string; // Company ID
  plateNumber?: string;
  service?: string; // Service ID
  addOns?: string;
  sortBy?: string;
  sortOrder?: string;
}

export async function fetchOrders(params: FetchOrdersParams = {}): Promise<PaginatedResponse> {
  try {
    const queryParams = new URLSearchParams();

    // Add all non-empty parameters to the query string
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.set(key, value.toString());
      }
    });

    // Set defaults if not provided
    if (!queryParams.has("page")) {
      queryParams.set("page", "1");
    }
    if (!queryParams.has("limit")) {
      queryParams.set("limit", "10");
    }
    if (!queryParams.has("sortBy")) {
      queryParams.set("sortBy", "createdAt");
    }
    if (!queryParams.has("sortOrder")) {
      queryParams.set("sortOrder", "desc");
    }

    const response = await axiosInstance.get(
      `${config.apiUrl}/orders?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.message || "Error fetching orders");
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
